import { render, staticRenderFns } from "./transferDetail.vue?vue&type=template&id=3ff1eeaa&scoped=true&"
import script from "./transferDetail.vue?vue&type=script&lang=ts&"
export * from "./transferDetail.vue?vue&type=script&lang=ts&"
import style0 from "./transferDetail.vue?vue&type=style&index=0&id=3ff1eeaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff1eeaa",
  null
  
)

export default component.exports